module.exports = __webpack_public_path__ + "img/V80.b8494676.jpg";